<h2 mat-dialog-title class="dialog-header">
  <span>Customer {{ userFiscalData.id || '' }}</span>
  <button mat-icon-button aria-label="Close" (click)="activeModal.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div class="form-grid two-columns">
    <mat-form-field appearance="outline">
      <mat-label>Company Name</mat-label>
      <input matInput [(ngModel)]="userFiscalData.companyName">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Address</mat-label>
      <input matInput [(ngModel)]="userFiscalData.address">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="email" [(ngModel)]="userFiscalData.email">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Phone</mat-label>
      <input matInput [(ngModel)]="userFiscalData.phone">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Type Card ID</mat-label>
      <mat-select [(ngModel)]="userFiscalData.typeCardId">
        <mat-option value="DNI">DNI</mat-option>
        <mat-option value="NIF">NIF</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Card ID</mat-label>
      <input matInput [(ngModel)]="userFiscalData.cardId">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>City</mat-label>
      <input matInput [(ngModel)]="userFiscalData.city">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Country</mat-label>
      <input matInput [(ngModel)]="userFiscalData.country">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Zip Code</mat-label>
      <input matInput [(ngModel)]="userFiscalData.zipCode">
    </mat-form-field>

    <mat-form-field *ngIf="!isNew" appearance="outline">
      <mat-label>User ID</mat-label>
      <input matInput [(ngModel)]="userFiscalData.userId">
    </mat-form-field>

    <mat-form-field appearance="outline" class="readonly-field">
      <mat-label>Created At</mat-label>
      <input matInput [value]="userFiscalData.createdAt | date: appService.FORMAT_DATETIME" readonly>
    </mat-form-field>

    <mat-form-field appearance="outline" class="readonly-field">
      <mat-label>Updated At</mat-label>
      <input matInput [value]="userFiscalData.updatedAt | date: appService.FORMAT_DATETIME" readonly>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <div class="dialog-actions-spread">
    <button *ngIf="!isNew" mat-stroked-button color="warn" (click)="deleteCustomer()">Eliminar</button>
    <button mat-raised-button color="primary" (click)="confirm()">Guardar</button>
  </div>
</mat-dialog-actions>
